import {globalStores} from '@stores'
import { CatalogInstanceChildStore } from '@stores/catalog/CatalogInstanceChildStore'

export interface IComment {
  parentCommentId?: string
  path?: string[]
  index: string
  indexItemId: string
  htmlContent: string
  userId: string
  timestamp: number
  _id: string
}

export class CommentsStore extends CatalogInstanceChildStore {
  loadCommentsForItem = async ({index, indexItemId} : {index: string, indexItemId: string}) => {
    const {es} = this
    const {items} = es.unwrapHitsResult<IComment>(await es.search({
      meta: `Load comments for ${index} - ${indexItemId}`,
      index: es.indexes.comment,
      body: {
        query: {
          bool: {
            must: [
              {
                match: {indexItemId}
              },
              {
                match: {index}
              },
            ]
          }
        },
        size: 1000,
        sort: [
          {
            timestamp: {
              order: 'desc',
              unmapped_type: 'date'
            }
          }
        ]
      }
    }, { log: {query: false}}))

    return items
  }

  addComment = async (comment: Partial<IComment>) => {
    const {es} = this
    return await es.genericUpsert({
      index: es.indexes.comment,
      _id: comment._id,
      body: {
        ..._.omit(comment, '_id'),
        userId: globalStores.authStore.user.id,
        timestamp: new Date().getTime()
      }})
  }

  deleteCommentAndAncestors = async (comment: Partial<IComment>) => {
    const {es} = this
    return await es.deleteByQuery({
      bool: {
        minimum_should_match: 1,
        should: [
          {term: { 'path.keyword': comment._id }},
          {term: {'_id': comment._id}},
        ]
      }
    }, es.indexes.comment)
  }
}



// WEBPACK FOOTER //
// ./src/stores/comments/CommentsStore.ts